// =================================================================================================================
// Breakpoints
// =================================================================================================================

// SET YOUR BREAKPOINT HERE
// Object of CSS breakpoints in pixels. Copy what you have in SCSS. Goes from smallest to largest.
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
}

/**
 * Get Current Breakpoint
 * Returns the name of the current breakpoint
 *
 * @param {object} breakpoints All of the CSS breakpoints. The key is the name of the breakpoint and the value is the width
 * @param {boolean} logBreakpoint Whether to log the breakpoint to the console or not
 * @param {string} currentBreakpoint The name of the current breakpoint
 */
function getCurrentBreakpoint(breakpoints, logBreakpoint= false, currentBreakpoint){
    // Get the window width
    let width = window.innerWidth;

    // Set the base breakpoint to the smallest one
    let breakpoint = Object.keys(breakpoints)[0];

    // Loop over the breakpoints object
    Object.entries(breakpoints).forEach(entry => {
        const [breakpointName, breakpointWidth] = entry;
        if (width > breakpointWidth ) {
            breakpoint = breakpointName;
        }
    });

    // If logging in enabled
    if (logBreakpoint) {
        if (currentBreakpoint){
            if (currentBreakpoint !== breakpoint){
                console.log("breakpoint:", breakpoint);
            }
        } else {
            console.log("breakpoint:", breakpoint);
        }
    }

    return breakpoint;
}

// Set breakpoint on page load
let breakpointCurrent = getCurrentBreakpoint(breakpoints, true);

// Change breakpoint on screen resize
window.addEventListener('resize', function (){
    breakpointCurrent = getCurrentBreakpoint(breakpoints, true, breakpointCurrent);
});


// =================================================================================================================
// Nav Bar
// =================================================================================================================

// Set up constants
// const nav = $("#main-nav"); // Nav bar
// const adminBar = $('#wpadminbar'); // WordPress Admin Bar
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling scrolled past start
// -----------------------------------------------------------------------------------------------------------------
window.onscroll = function() {
    const scrollPoint = 20; // pixel value after which state change is triggered
    this.scrollY > scrollPoint ? nav.classList.add('scrolled') : nav.classList.remove('scrolled');
};


// Check for WordPress admin bar and pushes Nav down if it exists
// -----------------------------------------------------------------------------------------------------------------
if (adminBar) {
    nav.style.top = adminBar.offsetHeight + 'px';

    window.addEventListener('resize', function (){
        nav.style.top = adminBar.offsetHeight + 'px';
    });
}



// =================================================================================================================
// Video Modals
// =================================================================================================================

const videoModals = document.querySelectorAll(".video-modal");
videoModals.forEach( modal => {

    // Play video in modal open (This can error out if the iframe is slow to load)
    modal.addEventListener('show.bs.modal', function(){
        let iframe = this.querySelector('iframe');
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'playVideo' }
            ), 'https://www.youtube.com'
        );
    })

    // Pause video on modal close
    modal.addEventListener('hide.bs.modal', function(){
        let iframe = this.querySelector('iframe');
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'pauseVideo' }
            ), 'https://www.youtube.com'
        );
    })

})


// =================================================================================================================
// Splide
// =================================================================================================================

import Splide from '@splidejs/splide';

if (document.getElementById('testimonials-slider')) {

    const testimonials = new Splide( '#testimonials-slider', {
        arrows: false,
        pagination: true,
        perPage: 1,
        perMove: 1,
        padding: 0,
        gap: 30,
        trimSpace: false,
        breakpoints: {
            992: {
                padding: 18
            },
        },

    } ).mount();

    testimonials.on('move', () => {
        testimonials.Components.Slides.forEach(function(slide) {
            let button = slide.slide.querySelector('.testimonial-btn');
            button.setAttribute('disabled', true);
        })
    });
    testimonials.on('moved', () => {
        testimonials.Components.Slides.forEach(function(slide) {
            let button = slide.slide.querySelector('.testimonial-btn');
            if (slide.slide.classList.contains('is-active')){
                button.removeAttribute('disabled');
            }
        })
    });
}

